import { render, staticRenderFns } from "./ComprasTabela.vue?vue&type=template&id=7fd19096"
import script from "./ComprasTabela.vue?vue&type=script&lang=js"
export * from "./ComprasTabela.vue?vue&type=script&lang=js"
import style0 from "./ComprasTabela.vue?vue&type=style&index=0&id=7fd19096&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports